<template>
  <div>
    <el-dialog
      class="basic_img_scale"
      title=""
      :visible.sync="show_pop"
      append-to-body
      :show-close="false"
      :modal="false"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <i
        class="iconfont icon-chuyidong icon-close"        
        id="img_scale_close"
        @click="handleClose"
        style="display: block"
      ></i>

      <div class="img-scale">
        <div class="arrow">
          <i class="icon-arrow fa fa-angle-left" @click.stop="arrow(true)"></i>
        </div>
        <div class="img-center">
          <img :src="videoUpdate[index]" alt="" class="img" ref="img_scale" />
        </div>
        <div class="arrow">
          <i class="icon-arrow fa fa-angle-right" @click.stop="arrow(false)"></i>
        </div>
      </div>
      <div class="btns">
        <i class="icon-scale el-icon-zoom-in" @click.stop="scaleUpdate(true)"></i>
        <i
          :class="[
            'icon-scale',
            'el-icon-zoom-out',
            scale <= 0.1 ? 'icon-scale-disabled' : '',
          ]"
          @click.stop="scaleUpdate(false)"
          :disabled="scale <= 0.1"
        ></i>
        <!-- <el-button type="primary" @click="scaleUpdate(true)"> 放大</el-button>
        <el-button @click="scaleUpdate(false)" :disabled="this.scale<=0.1">缩小</el-button> -->
      </div>
    
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  // 图片 放大 和缩小
  props: {
    showPop: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
      default: "",
    },
    videoUpdate: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show_pop: this.showPop,
      scale: 1,
      index: 0,
    };
  },
  methods: {
    handleClose() {
      this.show_pop = false;
      this.$emit("update:showPop", false);
    },
    scaleUpdate(type) {
      let step = 0.1;
      if (type) step = 0.1;
      if (!type) step = -0.1;
      let dom = this.$refs.img_scale;
      this.scale += step;
      if (this.scale < 0.1) this.scale = 0.1;
      dom.style.transform = `scale(${this.scale})`;
    },
    arrow(type) {
      this.scale = 1;
      let dom = this.$refs.img_scale;
      dom.style.transform = `scale(${this.scale})`;
      if (!type) {
        this.index =
          this.index + 1 === this.videoUpdate.length ? 0 : this.index + 1;
      } else {
        this.index =
          this.index == 0 ? this.videoUpdate.length - 1 : this.index - 1;
      }
    },
  },
  watch: {
    showPop(val) {
      this.show_pop = val;
      this.scale = 1;
      let dom = this.$refs.img_scale;
      dom && (dom.style.transform = `scale(${this.scale})`);
      if (val) {
        this.index = this.videoUpdate.findIndex((item) => item === this.imgUrl);
      }
    },
  },
};
</script>

<style scoped lang="scss">
#img_scale_close {
  color: #777;
  font-size: 26px;
  cursor: pointer;
  background-color: #fff;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 50px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.basic_img_scale {
  /deep/ .el-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-top: 0% !important;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    .el-dialog__header {
      height: 40px;
      box-sizing: border-box;
    }
    .el-dialog__body {
      height: calc(100% - 40px);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      padding: 0px;
      .img-scale {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .img-center {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          overflow: hidden;
          .img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            margin: 0 20px;
          }
        }
        .arrow {
          flex: 0 0 70px;
          width: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 70px;
          background-color: #fff;
          .icon-arrow {
            font-size: 50px;
            color: #777;
            cursor: pointer;
          }
        }
      }
      .btns {
        margin-top: 30px;
        flex: 0 0 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        .icon-scale {
          color: #fff;
          font-size: 30px;
          margin-right: 60px;
          cursor: pointer;
          &.icon-scale-disabled {
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/img_scale/index.vue